import React from "react";
import PropTypes from "prop-types";
import { TableCell, TableRow } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "../../../../components/Menu";
import Table from "../../../../components/Table";
import EmptyState from "../../../../components/EmptyState";
import messages from "../../../../assets/locale/messages";
import {formatDate} from "../../../../utils/Helpers";
import emptyPlaceholder from "../../../../assets/images/timesheet-screen/empty-report-placeholder.svg";

const TrainingAttendanceTable = ({
  list = [],
  lang,
  onEdit,
  onDelete,
  editDeleteActions = [],
}) => {
  const { timeSheet, shared } = messages[lang];

  if (!list?.length) {
    return (
      <div className="bg-white rounded-4 d-flex justify-content-center align-items-center flex-column my-4 py-5">
        <EmptyState
          description={timeSheet.placeholder}
          imgSrc={emptyPlaceholder}
          showActionButton={false}
        />
      </div>
    );
  }

  return (
    <div className="bg-white rounded-4 mt-2 pb-3">
      <Table
        className="rounded-4"
        headlines={[
          timeSheet.date,
          timeSheet.checkin,
          timeSheet.checkout,
          timeSheet.applicantReport.trainingHoursPerDay,
          timeSheet.monthlyReport.checkoutStatus,
          shared.actions,
        ]}
        hasActions={false}
        hasSizeLimitation={false}
        rows={list.map((row, i) => (
          <TableRow
            key={i}
            className={`${row.is_checked_out_automatically ? "flagged-row" : ""}`}
          >
            <TableCell>
              {row.check_in_readable_date || "-"}
            </TableCell>
            <TableCell>
              {row.check_in_at
                ? formatDate(row.check_in_at, "HH:mm:ss")
                : "-"}
            </TableCell>
            <TableCell>
              {row.check_out_at
                ? formatDate(row.check_out_at, "HH:mm:ss")
                : "-"}
            </TableCell>
            <TableCell
              className={`mobile-style ${lang === "ar" && "text-end"}`}
              dir={lang === "ar" ? "rtl" : "ltr"}
            >
              {row.working_hours}
            </TableCell>
            <TableCell
              className={`mobile-style ${lang === "ar" && "text-end"}`}
              dir="ltr"
            >
              {row.check_out_at && row.is_checked_out_automatically
                ? timeSheet.monthlyReport.automaticCheckout
                : row.check_out_at
                ? timeSheet.monthlyReport.selfCheckout
                : timeSheet.monthlyReport.checkoutStatusPending}
            </TableCell>
            <TableCell className="mobile-style">
              <Menu
                options={editDeleteActions}
                onSelectItem={(option) => {
                  if (option === shared.edit || option === "تعديل") {
                    onEdit?.(row);
                  } else if (option === shared.delete || option === "حذف") {
                    onDelete?.(row);
                  }
                }}
                triggerIcon={<MoreVertIcon />}
                paperProps={{
                  style: { width: "15ch", color: "#6B778C" },
                }}
              />
            </TableCell>
          </TableRow>
        ))}
      />
    </div>
  );
};

TrainingAttendanceTable.propTypes = {
  list: PropTypes.array,
  lang: PropTypes.string.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  editDeleteActions: PropTypes.array,
};

export default TrainingAttendanceTable;
